import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import Report from "@/pages/Dashboard/Report.vue";

// Pages
import Login from "@/pages/Dashboard/Pages/Login.vue";
// import Register from "@/pages/Dashboard/Pages/Register.vue";
import Lock from "@/pages/Dashboard/Pages/Lock.vue";

// Components pages
import Buttons from "@/pages/Dashboard/Components/Buttons.vue";
import GridSystem from "@/pages/Dashboard/Components/GridSystem.vue";
import Panels from "@/pages/Dashboard/Components/Panels.vue";
import SweetAlert from "@/pages/Dashboard/Components/SweetAlert.vue";
import Notifications from "@/pages/Dashboard/Components/Notifications.vue";
import Icons from "@/pages/Dashboard/Components/Icons.vue";
import Typography from "@/pages/Dashboard/Components/Typography.vue";

// Forms pages
import RegularForms from "@/pages/Dashboard/Forms/RegularForms.vue";
import ExtendedForms from "@/pages/Dashboard/Forms/ExtendedForms.vue";
import ValidationForms from "@/pages/Dashboard/Forms/ValidationForms.vue";
import Wizard from "@/pages/Dashboard/Forms/Wizard.vue";

// TableList pages
import RegularTables from "@/pages/Dashboard/Tables/RegularTables.vue";
import ExtendedTables from "@/pages/Dashboard/Tables/ExtendedTables.vue";
import PaginatedTables from "@/pages/Dashboard/Tables/PaginatedTables.vue";

// Maps pages
// import GoogleMaps from "@/pages/Dashboard/Maps/GoogleMaps.vue";
// import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";
// import VectorMaps from "@/pages/Dashboard/Maps/VectorMaps.vue";

// Calendar
// import Calendar from "@/pages/Dashboard/Calendar.vue";
// Charts
// import Charts from "@/pages/Dashboard/Charts.vue";
// import Widgets from "@/pages/Dashboard/Widgets.vue";

// CMS Pages
import Pages from "@/pages/CMS/Pages/Pages.vue";
import PageDetails from "@/pages/CMS/Pages/PageDetails.vue";
import Leads from "@/pages/CMS/Leads.vue";
import Kiosks from "@/pages/KioskManagement/Kiosks/Kiosks.vue";
import KioskDetails from "@/pages/KioskManagement/Kiosks/KioskDetails.vue";
import Stores from "@/pages/KioskManagement/Stores/Stores.vue";
import StoreDetails from "@/pages/KioskManagement/Stores/StoreDetails.vue";
import Contractors from "@/pages/KioskManagement/Contractors/Contractors.vue";
import ContractorDetails from "@/pages/KioskManagement/Contractors/ContractorDetails.vue";
import Locations from "@/pages/KioskManagement/Locations/Locations.vue";
import LocationDetails from "@/pages/KioskManagement/Locations/LocationDetails.vue";
import Cannabis from "@/pages/KioskManagement/Cannabis/Cannabis.vue";
import CannabisDetails from "@/pages/KioskManagement/Cannabis/CannabisDetails.vue";

import Services from "@/pages/Settings/Services.vue";
import Advertisements from "@/pages/KioskManagement/Advertisements/Advertisements.vue";
import AdvertisementsDetails from "@/pages/KioskManagement/Advertisements/AdvertisementsDetails.vue";
import PageVisits from "@/pages/CMS/PageVisits.vue";
import Emails from "@/pages/CMS/Emails.vue";
import Orders from "@/pages/CMS/Orders.vue";
import Customers from "@/pages/CMS/Customers.vue";
import CustomerDetails from "@/pages/CMS/CustomerDetails.vue";
import OrderDetails from "@/pages/CMS/OrderDetails";
import Register from "@/pages/Administration/Administration.vue";

import Products from "@/pages/CMS/Products.vue";
import ProductDetails from "@/pages/CMS/ProductDetails";
import Videos from "@/pages/Videos/Videos";
import VideoDetails from "@/pages/Videos/VideoDetails";

import Clients from "@/pages/ClientManagement/Clients.vue";
import ClientDetails from "@/pages/ClientManagement/ClientDetails.vue";

// import Referrals from "@/pages/CMS/Referrals.vue";
// import ScanDetails from "@/pages/CMS/ScanDetails";

// import Login from "@/pages/Auth/Login.vue";
// import Videos from "@/pages/CMS/PageVisits.vue";

import Library from "@/pages/MediaLibrary/Library.vue";
import Gallery from "@/pages/MediaLibrary/Galleries.vue";
import GalleryDetails from "@/pages/MediaLibrary/GalleryDetails.vue";
import Collection from "@/pages/MediaLibrary/Collections.vue";
import CollectionDetails from "@/pages/MediaLibrary/CollectionDetails.vue";
// Kiosk Management Pages

import Contacts from "@/pages/Contacts/Contacts.vue";

import Announcement from "@/pages/Announcement/Announcement.vue";
import Announcements from "@/pages/Announcement/Announcements.vue";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons },
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem },
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels },
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert },
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications },
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons },
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography },
    },
  ],
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms },
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms },
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms },
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables },
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables },
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: { default: PaginatedTables },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Pages",
      components: { default: Pages },
    },
    {
      path: ":page_id",
      name: "Page Details",
      components: { default: PageDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let leadsMenu = {
  path: "/leads",
  component: DashboardLayout,
  name: "Leads",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Leads",
      components: { default: Leads },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let kiosksMenu = {
  path: "/kiosks",
  component: DashboardLayout,
  name: "Kiosks",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Kiosks",
      components: { default: Kiosks },
    },
    {
      path: ":kiosk_id",
      name: "Kiosk Details",
      components: { default: KioskDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let cannabisMenu = {
  path: "/flavors",
  component: DashboardLayout,
  name: "Flavors",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Flavors",
      components: { default: Cannabis },
    },
    {
      path: ":cannabis_id",
      name: "Flavor  Details",
      components: { default: CannabisDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let storesMenu = {
  path: "/stores",
  component: DashboardLayout,
  name: "Stores",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Stores",
      components: { default: Stores },
    },
    {
      path: ":store_id",
      name: "Store Details",
      components: { default: StoreDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let locationsMenu = {
  path: "/locations",
  component: DashboardLayout,
  name: "Locations",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Locations",
      components: { default: Locations },
    },
    {
      path: ":location_id",
      name: "Location Details",
      components: { default: LocationDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let reportMenu = {
  path: "/report",
  component: DashboardLayout,
  name: "Report",
  redirect: "/",
  children: [
    {
      path: ":destination_id",
      name: "Destination Report",
      components: { default: Report },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let viewReportMenu = {
  path: "/reportview",
  component: Report,
  name: "View Report",
  redirect: "/",
  children: [
    {
      path: ":destination_id",
      name: "View Report",
      components: { default: Report },
    },
  ],
};

let adveertisementsMenu = {
  path: "/advertisements",
  component: DashboardLayout,
  name: "Advertisements",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Advertisements",
      components: { default: Advertisements },
    },
    {
      path: ":advertisement_id",
      name: "Advertisement Details",
      components: { default: AdvertisementsDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let contractorsMenu = {
  path: "/contractors",
  component: DashboardLayout,
  name: "Contractors",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Contractors",
      components: { default: Contractors },
    },
    {
      path: ":contractor_id",
      name: "Contractor Details",
      components: { default: ContractorDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let clientMenu = {
  path: "/clients",
  component: DashboardLayout,
  name: "Clients",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Clients",
      components: { default: Clients },
    },
    {
      path: ":client_id",
      name: "Client Details",
      components: { default: ClientDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let pageVisits = {
  path: "/pagevisits",
  component: DashboardLayout,
  name: "PageVisits",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Page Visits",
      components: { default: PageVisits },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let mediaLibrary = {
  path: "/library",
  component: DashboardLayout,
  name: "Media Library",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Media Library",
      component: Library,
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let mediaGallery = {
  path: "/gallery",
  component: DashboardLayout,
  name: "Gallery",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Gallery",
      components: { default: Gallery },
    },
    {
      path: ":gallery_id",
      name: "Gallery Details",
      components: { default: GalleryDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let mediaCollection = {
  path: "/collection",
  component: DashboardLayout,
  name: "Collection",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Collection",
      components: { default: Collection },
    },
    {
      path: ":collection_id",
      name: "Collection Details",
      components: { default: CollectionDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let emails = {
  path: "/emails",
  component: DashboardLayout,
  name: "emails",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Emails",
      components: { default: Emails },
    },
    {
      path: ":id",
      name: "Specific Emails",
      components: { default: Emails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let videos = {
  path: "/videos",
  component: DashboardLayout,
  name: "videos",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Videos",
      components: { default: Videos },
    },
    {
      path: ":id",
      name: "Specific Videos",
      components: { default: VideoDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

// let referrals = {
//   path: "/scans",
//   component: DashboardLayout,
//   name: "scans",
//   redirect: "/",
//   children: [
//     {
//       path: "/",
//       name: "Scan Appointments",
//       components: { default: Referrals }
//     },
//     {
//       path: ":scan_id",
//       name: "Scan Details",
//       components: { default: ScanDetails }
//     }
//   ],
//   meta: {
//     requiresAuth: true
//   }
// };

let customers = {
  path: "/customers",
  component: DashboardLayout,
  name: "customers",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Customers",
      components: { default: Customers },
    },
    {
      path: ":customer_id",
      name: "Customer Details",
      components: { default: CustomerDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let orders = {
  path: "/orders",
  component: DashboardLayout,
  name: "orders",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Orders",
      components: { default: Orders },
    },
    {
      path: ":order_id",
      name: "Order Details",
      components: { default: OrderDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let products = {
  path: "/products",
  component: DashboardLayout,
  name: "products",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Products",
      components: { default: Products },
    },
    {
      path: ":product_id",
      name: "Product Details",
      components: { default: ProductDetails },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let register = {
  path: "/register",
  component: DashboardLayout,
  name: "register",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "register",
      components: { default: Register },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let announcement = {
  path: "/announcements",
  component: DashboardLayout,
  name: "Announcements",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Announcements",
      components: { default: Announcements },
    },
    {
      path: ":id",
      name: "Announcement",
      components: { default: Announcement },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let contacts = {
  path: "/contacts",
  component: DashboardLayout,
  name: "Contacts",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Contacts",
      components: { default: Contacts },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let servicesMenu = {
  path: "/services",
  component: DashboardLayout,
  name: "Services",
  redirect: "/",
  children: [
    {
      path: "/",
      name: "Services",
      components: { default: Services },
    },
  ],
  meta: {
    requiresAuth: true,
  },
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    // {
    //   path: "/register",
    //   name: "Register",
    //   component: Register
    // },
    // {
    //   path: "/pricing",
    //   name: "Pricing",
    //   component: Pricing
    // },
    {
      path: "/lock",
      name: "Lock",
      component: Lock,
    },
  ],
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
  },
  {
    path: "*",
    redirect: "/dashboard",
    name: "Home",
  },
  componentsMenu,
  formsMenu,
  mediaLibrary,
  tablesMenu,
  // mapsMenu,
  pagesMenu,
  clientMenu,
  kiosksMenu,
  storesMenu,
  locationsMenu,
  adveertisementsMenu,
  contractorsMenu,
  servicesMenu,
  cannabisMenu,
  authPages,
  pageVisits,
  emails,
  contacts,
  authPages,
  mediaGallery,
  mediaCollection,
  leadsMenu,
  reportMenu,
  viewReportMenu,
  announcement,
  customers,
  orders,
  products,
  register,
  videos,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
        meta: {
          requiresAuth: true,
        },
      },
    ],
    meta: {
      requiresAuth: true,
    },
  },
];

export default routes;
